var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnbMyOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji_emotions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3003 11C17.1287 11 17.8003 10.3284 17.8003 9.5C17.8003 8.67157 17.1287 8 16.3003 8C15.4719 8 14.8003 8.67157 14.8003 9.5C14.8003 10.3284 15.4719 11 16.3003 11Z",
    fill: "#00BF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30029 11C10.1287 11 10.8003 10.3284 10.8003 9.5C10.8003 8.67157 10.1287 8 9.30029 8C8.47187 8 7.80029 8.67157 7.80029 9.5C7.80029 10.3284 8.47187 11 9.30029 11Z",
    fill: "#00BF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8003 18C15.0803 18 17.0203 16.34 17.8003 14H7.80029C8.58029 16.34 10.5203 18 12.8003 18Z",
    fill: "#00BF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7903 2C7.27029 2 2.80029 6.48 2.80029 12C2.80029 17.52 7.27029 22 12.7903 22C18.3203 22 22.8003 17.52 22.8003 12C22.8003 6.48 18.3203 2 12.7903 2ZM12.8003 20C8.38029 20 4.80029 16.42 4.80029 12C4.80029 7.58 8.38029 4 12.8003 4C17.2203 4 20.8003 7.58 20.8003 12C20.8003 16.42 17.2203 20 12.8003 20Z",
    fill: "#00BF9D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbMyOn);
export default __webpack_public_path__ + "static/media/gnb_my_on.2aa4d25506a259c302f4eeb88dc9ed5e.svg";
export { ForwardRef as ReactComponent };